// import axios from "axios";
import axiosBackEnd from "../../config/axios/axios-back-end";
import * as actionTypes from "./actionTypes";
import { message } from "antd";

import apiErrorHandler from "./helper/apiErrorHandler";

export const apiStart = () => {
  return {
    type: actionTypes.API_START,
  };
};

export const apiComplete = () => {
  return {
    type: actionTypes.API_COMPLETE,
  };
};
export const apiFail = (error) => {
  return {
    type: actionTypes.API_FAIL,
    error: error,
  };
};

export const setNull = (data) => {
  return {
    type: actionTypes.SET_NULL,
    data: data,
  };
};

export const setSmDataSuccess = (data) => {
  return {
    type: actionTypes.SET_SM_DATA_SUCCESS,
    data: data,
  };
};
export const userGetSuccess = (data) => {
  return {
    type: actionTypes.USER_GET_SUCCESS,
    data: data,
  };
};
export const userListGetSuccess = (data) => {
  return {
    type: actionTypes.USER_LIST_GET_SUCCESS,
    data: data,
  };
};
export const userCreateSuccess = (data) => {
  return {
    type: actionTypes.USER_CREATE_SUCCESS,
    data: data,
  };
};
export const userUpdateSuccess = (data) => {
  return {
    type: actionTypes.USER_UPDATE_SUCCESS,
    data: data,
  };
};

export const hmgGetSuccess = (data) => {
  return {
    type: actionTypes.HMG_GET_SUCCESS,
    data: data,
  };
};
export const hmgCreateSuccess = (data) => {
  return {
    type: actionTypes.HMG_CREATE_SUCCESS,
    data: data,
  };
};
export const hmgUpdateSuccess = (data) => {
  return {
    type: actionTypes.HMG_UPDATE_SUCCESS,
    data: data,
  };
};
export const hmgHotelListSuccess = (data) => {
  return {
    type: actionTypes.HMG_GET_HOTELS_SUCCESS,
    data: data,
  };
};
export const hmgProjectsHotelListSuccess = (data) => {
  return {
    type: actionTypes.HMG_GET_PROJECTS_HOTELS_SUCCESS,
    data: data,
  };
};

export const hmgMainGetSuccess = (data) => {
  return {
    type: actionTypes.HMG_MAIN_GET_SUCCESS,
    data: data,
  };
};
export const hmgMainCreateSuccess = (data) => {
  return {
    type: actionTypes.HMG_MAIN_CREATE_SUCCESS,
    data: data,
  };
};
export const hmgMainUpdateSuccess = (data) => {
  return {
    type: actionTypes.HMG_MAIN_UPDATE_SUCCESS,
    data: data,
  };
};

export const hotelGetSuccess = (data) => {
  return {
    type: actionTypes.HOTEL_GET_SUCCESS,
    data: data,
  };
};
export const hotelCreateSuccess = (data) => {
  return {
    type: actionTypes.HOTEL_CREATE_SUCCESS,
    data: data,
  };
};
export const hotelUpdateSuccess = (data) => {
  return {
    type: actionTypes.HOTEL_UPDATE_SUCCESS,
    data: data,
  };
};

export const rolesGetSuccess = (data) => {
  return {
    type: actionTypes.ROLES_GET_SUCCESS,
    data: data,
  };
};

export const rolesListGetSuccess = (data) => {
  return {
    type: actionTypes.ROLES_LIST_GET_SUCCESS,
    data: data,
  };
};
export const roleCreateSuccess = (data) => {
  return {
    type: actionTypes.ROLE_CREATE_SUCCESS,
    data: data,
  };
};
export const roleUpdateSuccess = (data) => {
  return {
    type: actionTypes.ROLE_UPDATE_SUCCESS,
    data: data,
  };
};

export const reportsGetSuccess = (data) => {
  return {
    type: actionTypes.REPORTS_GET_SUCCESS,
    data: data,
  };
};

export const indexesGetSuccess = (data) => {
  return {
    type: actionTypes.INDEXES_GET_SUCCESS,
    data: data,
  };
};
export const indexeCreateSuccess = (data) => {
  return {
    type: actionTypes.INDEXE_CREATE_SUCCESS,
    data: data,
  };
};
export const indexeUpdateSuccess = (data) => {
  return {
    type: actionTypes.INDEXE_UPDATE_SUCCESS,
    data: data,
  };
};

export const pmsGetSuccess = (data) => {
  return {
    type: actionTypes.PMS_GET_SUCCESS,
    data: data,
  };
};

export const solutionsGetSuccess = (data) => {
  return {
    type: actionTypes.SOLUTIONS_GET_SUCCESS,
    data: data,
  };
};

export const mainRolesGetSuccess = (data) => {
  return {
    type: actionTypes.MAIN_ROLES_GET_SUCCESS,
    data: data,
  };
};
export const mainRoleCreateSuccess = (data) => {
  return {
    type: actionTypes.MAIN_ROLE_CREATE_SUCCESS,
    data: data,
  };
};
export const mainRoleUpdateSuccess = (data) => {
  return {
    type: actionTypes.MAIN_ROLE_UPDATE_SUCCESS,
    data: data,
  };
};

export const applicationsGetSuccess = (data) => {
  return {
    type: actionTypes.APPLICATIONS_GET_SUCCESS,
    data: data,
  };
};

export const hotelsGroupsGetSuccess = (data) => {
  return {
    type: actionTypes.HOTELS_GROUPS_GET_SUCCESS,
    data: data,
  };
};
export const hotelsGroupCreateSuccess = (data) => {
  return {
    type: actionTypes.HOTELS_GROUP_CREATE_SUCCESS,
    data: data,
  };
};
export const hotelsGroupUpdateSuccess = (data) => {
  return {
    type: actionTypes.HOTELS_GROUP_UPDATE_SUCCESS,
    data: data,
  };
};

export const signersGroupsGetSuccess = (data) => {
  return {
    type: actionTypes.SIGNERS_GROUPS_GET_SUCCESS,
    data: data,
  };
};
export const signersGroupCreateSuccess = (data) => {
  return {
    type: actionTypes.SIGNERS_GROUP_CREATE_SUCCESS,
    data: data,
  };
};
export const signersGroupUpdateSuccess = (data) => {
  return {
    type: actionTypes.SIGNERS_GROUP_UPDATE_SUCCESS,
    data: data,
  };
};
export const signersGroupsHotelUpdateSuccess = (data) => {
  return {
    type: actionTypes.SIGNERS_GROUPS_HOTEL_UPDATE_SUCCESS,
    data: data,
  };
};

export const bulkUserCreationSuccess = (data) => {
  return {
    type: actionTypes.BULK_USER_CREATION_SUCCESS,
    data: data,
  };
};

export const bulkReportCategoryCreationSuccess = (data) => {
  return {
    type: actionTypes.BULK_REPORT_CATEGORY_CREATION_SUCCESS,
    data: data,
  };
};

export const outOfOfficeCreateSuccess = (data) => {
  return {
    type: actionTypes.OUT_OF_OFFICE_CREATE_SUCCESS,
    data: data,
  };
};
export const outOfOfficeUpdateSuccess = (data) => {
  return {
    type: actionTypes.OUT_OF_OFFICE_UPDATE_SUCCESS,
    data: data,
  };
};

export const deleteItemSuccess = (data) => {
  return {
    type: actionTypes.DELETE_ITEM_SUCCESS,
    data: data,
  };
};

export const setSmData = (email) => {
  return async (dispatch) => {
    dispatch(apiStart());

    const headers = {
      "Content-Type": "application/json",
    };
    try {
      const response = await axiosBackEnd.get("/api/users/login", null, {
        headers: headers,
      });
      dispatch(setSmDataSuccess(response.data));
    } catch (error) {
      message.error(error.message);
      dispatch(apiFail(error.message));
    }

    return "done";
  };
};

export const userGetById = (data) => {
  const queryData = { user_id: data?.user_id, role_id: data?.role_id }
  return async (dispatch) => {
    dispatch(apiStart());
    const headers = {
      "Content-Type": "application/json",
    };
    try {
      const response = await axiosBackEnd.get("/api/users/legacy", {
        headers: headers,
        params: queryData,
      });
      dispatch(apiComplete());
      // message.success(response.data.message);
      return response.data;
    } catch (err) {
      if (err.response) {
        const errors = err.response.data.errors;
        if (errors) {
          errors.forEach((error) => message.error(error.msg));
        }
        dispatch(apiFail(err.response.data));
      } else {
        message.error(err.message);
        dispatch(apiFail(err.message));
      }
      return false;
    }
  };
};

export const userGet = () => {
  // const queryData = { user_id: data.user_id, role_id: data.role_id }
  return async (dispatch) => {
    dispatch(apiStart());
    const headers = {
      "Content-Type": "application/json",
    };
    try {
      const response = await axiosBackEnd.get("/api/users/legacy", null, {
        headers: headers,
      });
      dispatch(userGetSuccess(response.data));
      console.log(response.data)
      return true;
    } catch (err) {
      if (err.response) {
        const errors = err.response.data.errors;
        if (errors) {
          errors.forEach((error) => message.error(error.msg));
        }
        dispatch(apiFail(err.response.data));
      } else {
        message.error(err.message);
        dispatch(apiFail(err.message));
      }

      return false;
    }
  };
};

export const userListGet = (data) => {
  return async (dispatch) => {
    dispatch(apiStart());
    const headers = {
      "Content-Type": "application/json",
    };
    try {
      const response = await axiosBackEnd.get("/api/users/list", null, {
        params: data,
        headers: headers,
      });
      dispatch(userListGetSuccess(response.data));

      return true;
    } catch (err) {
      if (err.response) {
        const errors = err.response.data.errors;
        if (errors) {
          errors.forEach((error) => message.error(error.msg));
        }
        dispatch(apiFail(err.response.data));
      } else {
        message.error(err.message);
        dispatch(apiFail(err.message));
      }

      return false;
    }
  };
};

export const userCreate = (data) => {
  return async (dispatch) => {
    dispatch(apiStart());
    const headers = {
      "Content-Type": "application/json",
    };
    try {
      const response = await axiosBackEnd.post("/api/users", data, { headers: headers });
      // dispatch(userCreateSuccess(response.data));
      dispatch(apiComplete())
      message.success(response.data.message);
      return response;
    } catch (err) {
      if (err.response) {
        const errors = err.response.data.errors;
        if (errors) {
          errors.forEach((error) => message.error(error.msg));
        }
        dispatch(apiFail(err.response.data));
      } else {
        message.error(err.message);
        dispatch(apiFail(err.message));
      }
      return false;
    }
  };
};

export const userUpdate = (data) => {
  return async (dispatch) => {
    dispatch(apiStart());
    const headers = {
      "Content-Type": "application/json",
    };
    try {
      const response = await axiosBackEnd.post("/api/users/update", data, { headers: headers });
      // dispatch(userUpdateSuccess(response.data));
      dispatch(apiComplete());
      message.success(response.data.message);
      return true;
    }
    catch (err) {
      console.log(err, 'update error')
      if (err.response) {
        const errors = err.response.data.errors;
        if (errors) {
          errors.forEach((error) => message.error(error.msg));
        }
        dispatch(apiFail(err.response.data));
      } else {
        message.error(err.message);
        dispatch(apiFail(err.message));
      }
      return false;
    }
  };
};

export const hmgGet = () => {
  return async (dispatch) => {
    dispatch(apiStart());
    const headers = {
      "Content-Type": "application/json",
    };
    try {
      const response = await axiosBackEnd.get("/api/hmg", null, {
        headers: headers,
      });
      dispatch(hmgGetSuccess(response.data));

      return true;
    } catch (err) {
      if (err.response) {
        const errors = err.response.data.errors;
        if (errors) {
          errors.forEach((error) => message.error(error.msg));
        }
        dispatch(apiFail(err.response.data));
      } else {
        message.error(err.message);
        dispatch(apiFail(err.message));
      }
      return false;
    }
  };
};

export const hmgCreate = (data) => {
  return async (dispatch) => {
    dispatch(apiStart());
    const headers = {
      "Content-Type": "application/json",
    };
    try {
      const response = await axiosBackEnd.post("/api/hmg", data, {
        headers: headers,
      });
      dispatch(hmgCreateSuccess(response.data));
      message.success(response.data.message);
      return true;
    } catch (err) {
      if (err.response) {
        const errors = err.response.data.errors;
        if (errors) {
          errors.forEach((error) => message.error(error.msg));
        }
        dispatch(apiFail(err.response.data));
      } else {
        message.error(err.message);
        dispatch(apiFail(err.message));
      }
      return false;
    }
  };
};

export const hmgUpdate = (data) => {
  return async (dispatch) => {
    dispatch(apiStart());
    const headers = {
      "Content-Type": "application/json",
    };
    try {
      const response = await axiosBackEnd.post("/api/hmg/update", data, {
        headers: headers,
      });
      dispatch(hmgUpdateSuccess(response.data));
      message.success(response.data.message);
      return true;
    } catch (err) {
      if (err.response) {
        const errors = err.response.data.errors;
        if (errors) {
          errors.forEach((error) => message.error(error.msg));
        }
        dispatch(apiFail(err.response.data));
      } else {
        message.error(err.message);
        dispatch(apiFail(err.message));
      }
      return false;
    }
  };
};

export const hmgMainGet = () => {
  return async (dispatch) => {
    dispatch(apiStart());
    const headers = {
      "Content-Type": "application/json",
    };
    try {
      const response = await axiosBackEnd.get("/api/hmg-main", null, {
        headers: headers,
      });
      dispatch(hmgMainGetSuccess(response.data));

      return true;
    } catch (err) {
      if (err.response) {
        const errors = err.response.data.errors;
        if (errors) {
          errors.forEach((error) => message.error(error.msg));
        }
        dispatch(apiFail(err.response.data));
      } else {
        message.error(err.message);
        dispatch(apiFail(err.message));
      }

      return false;
    }
  };
};

export const hmgMainCreate = (data) => {
  return async (dispatch) => {
    dispatch(apiStart());
    const headers = {
      "Content-Type": "application/json",
    };
    try {
      const response = await axiosBackEnd.post("/api/hmg-main", data, {
        headers: headers,
      });
      dispatch(hmgMainCreateSuccess(response.data));
      message.success(response.data.message);
      return true;
    } catch (err) {
      if (err.response) {
        const errors = err.response.data.errors;
        if (errors) {
          errors.forEach((error) => message.error(error.msg));
        }
        dispatch(apiFail(err.response.data));
      } else {
        message.error(err.message);
        dispatch(apiFail(err.message));
      }
      return false;
    }
  };
};

export const hmgMainUpdate = (data) => {
  return async (dispatch) => {
    dispatch(apiStart());
    const headers = {
      "Content-Type": "application/json",
    };
    try {
      const response = await axiosBackEnd.post("/api/hmg-main/update", data, {
        headers: headers,
      });
      dispatch(hmgMainUpdateSuccess(response.data));
      message.success(response.data.message);
      return true;
    } catch (err) {
      if (err.response) {
        const errors = err.response.data.errors;
        if (errors) {
          errors.forEach((error) => message.error(error.msg));
        }
        dispatch(apiFail(err.response.data));
      } else {
        message.error(err.message);
        dispatch(apiFail(err.message));
      }
      return false;
    }
  };
};
//below hmgProjectsHotels and hmgHotels method are done the same thing except hmgProjectsHotels pass multiple ids since
// signature QC need to have multiple project being selected to get envelop status at a given intance.
export const hmgProjectsHotels = (id) => {
  return async (dispatch) => {
    dispatch(apiStart());
    const headers = {
      "Content-Type": "application/json",
    };
    try {
      const response = await axiosBackEnd.get(
        `/api/hmg/getProjecthotels?id=${id}`,
        null,
        { headers: headers }
      );
      dispatch(hmgProjectsHotelListSuccess(response.data));
      return true;
    } catch (err) {
      if (err.response) {
        const errors = err.response.data.errors;
        if (errors) {
          errors.forEach((error) => message.error(error.msg));
        }
        dispatch(apiFail(err.response.data));
      } else {
        message.error(err.message);
        dispatch(apiFail(err.message));
      }
      return false;
    }
  };
};

export const hmgHotels = (id) => {
  return async (dispatch) => {
    dispatch(apiStart());
    const headers = {
      "Content-Type": "application/json",
    };
    try {
      const response = await axiosBackEnd.get(
        `/api/hmg/gethotels?id=${id}`,
        null,
        { headers: headers }
      );
      dispatch(hmgHotelListSuccess(response.data));
      return true;
    } catch (err) {
      if (err.response) {
        const errors = err.response.data.errors;
        if (errors) {
          errors.forEach((error) => message.error(error.msg));
        }
        dispatch(apiFail(err.response.data));
      } else {
        message.error(err.message);
        dispatch(apiFail(err.message));
      }
      return false;
    }
  };
};

export const hotelGet = () => {
  return async (dispatch) => {
    dispatch(apiStart());
    const headers = {
      "Content-Type": "application/json",
    };
    try {
      const response = await axiosBackEnd.get("/api/hotels/legacy", null, {
        headers: headers,
      });
      dispatch(hotelGetSuccess(response.data));

      return true;
    } catch (err) {
      if (err.response) {
        const errors = err.response.data.errors;
        if (errors) {
          errors.forEach((error) => message.error(error.msg));
        }
        dispatch(apiFail(err.response.data));
      } else {
        message.error(err.message);
        dispatch(apiFail(err.message));
      }

      return false;
    }
  };
};

export const hotelCreate = (data) => {
  return async (dispatch) => {
    dispatch(apiStart());
    const headers = {
      "Content-Type": "application/json",
    };
    try {
      const response = await axiosBackEnd.post("/api/hotels/legacy", data, {
        headers: headers,
      });
      dispatch(hotelCreateSuccess(response.data));
      message.success(response.data.message);
      return true;
    } catch (err) {
      if (err.response) {
        const errors = err.response.data.errors;
        if (errors) {
          errors.forEach((error) => message.error(error.msg));
        }
        dispatch(apiFail(err.response.data));
      } else {
        message.error(err.message);
        dispatch(apiFail(err.message));
      }
      return false;
    }
  };
};

export const hotelUpdate = (data) => {
  return async (dispatch) => {
    dispatch(apiStart());
    const headers = {
      "Content-Type": "application/json",
    };
    try {
      const response = await axiosBackEnd.post("/api/hotels/update", data, {
        headers: headers,
      });
      dispatch(hotelUpdateSuccess(response.data));
      message.success(response.data.message);
      return true;
    } catch (err) {
      if (err.response) {
        const errors = err.response.data.errors;
        if (errors) {
          errors.forEach((error) => message.error(error.msg));
        }
        dispatch(apiFail(err.response.data));
      } else {
        message.error(err.message);
        dispatch(apiFail(err.message));
      }
      return false;
    }
  };
};

export const hotelBulkUpload = (data) => {
  return async (dispatch) => {
    // dispatch(apiStart());
    const headers = {
      "Content-Type": "application/json",
    };
    try {
      const response = await axiosBackEnd.post(
        "/api/hotels/bulk-upload",
        data,
        { headers: headers }
      );
      // dispatch(apiComplete());
      message.success(response.data.message);
      return { status: true, message: response.data.message };
    } catch (err) {
      // if(err.response){
      //   const errors = err.response.data.errors;
      //   if (errors) {
      //     errors.forEach(error => message.error(error.msg));
      //   }
      //   dispatch(apiFail(err.response.data));
      // }else {

      // }
      console.log(err.response.data);
      message.error(err.response.data);
      // dispatch(apiFail(err.message));
      return { status: false, message: err.response.data };
    }
  };
};

export const rolesGet = (data) => {
  const queryData = { role_id: data }
  return async (dispatch) => {
    dispatch(apiStart());
    const headers = {
      "Content-Type": "application/json",
    };
    try {
      const response = await axiosBackEnd.get("/api/roles", {
        params: queryData,
        headers: headers,
      });
      dispatch(rolesGetSuccess(response.data));

      return true;
    } catch (err) {
      if (err.response) {
        const errors = err.response.data.errors;
        if (errors) {
          errors.forEach((error) => message.error(error.msg));
        }
        dispatch(apiFail(err.response.data));
      } else {
        message.error(err.message);
        dispatch(apiFail(err.message));
      }

      return false;
    }
  };
};

export const rolesGetByMainRoleId = (id) => {
  return async (dispatch) => {
    dispatch(apiStart());
    const headers = {
      "Content-Type": "application/json",
    };
    try {
      const response = await axiosBackEnd.get(`/api/roles/get-role/${id}`, null, {
        headers: headers,
      });
      dispatch(apiComplete());
      return response.data;
    } catch (err) {
      if (err.response) {
        const errors = err.response.data.errors;
        if (errors) {
          errors.forEach((error) => message.error(error.msg));
        }
        dispatch(apiFail(err.response.data));
      } else {
        message.error(err.message);
        dispatch(apiFail(err.message));
      }
      return false;
    }
  };
};

export const rolesListGet = () => {
  return async (dispatch) => {
    dispatch(apiStart());
    const headers = {
      "Content-Type": "application/json",
    };
    try {
      const response = await axiosBackEnd.get("/api/roles/list", null, {
        headers: headers,
      });
      dispatch(rolesListGetSuccess(response.data));

      return true;
    } catch (err) {
      if (err.response) {
        const errors = err.response.data.errors;
        if (errors) {
          errors.forEach((error) => message.error(error.msg));
        }
        dispatch(apiFail(err.response.data));
      } else {
        message.error(err.message);
        dispatch(apiFail(err.message));
      }

      return false;
    }
  };
};

export const roleCreate = (data) => {
  return async (dispatch) => {
    dispatch(apiStart());
    const headers = {
      "Content-Type": "application/json",
    };
    try {
      const response = await axiosBackEnd.post("/api/roles", data, {
        headers: headers,
      });
      dispatch(roleCreateSuccess(response.data));
      message.success(response.data.message);
      return true;
    } catch (err) {
      if (err.response) {
        const errors = err.response.data.errors;
        if (errors) {
          errors.forEach((error) => message.error(error.msg));
        }
        dispatch(apiFail(err.response.data));
      } else {
        message.error(err.message);
        dispatch(apiFail(err.message));
      }
      return false;
    }
  };
};

export const roleUpdate = (data) => {
  return async (dispatch) => {
    dispatch(apiStart());
    const headers = {
      "Content-Type": "application/json",
    };
    try {
      const response = await axiosBackEnd.post("/api/roles/update", data, {
        headers: headers,
      });
      dispatch(roleUpdateSuccess(response.data));
      message.success(response.data.message);
      return true;
    } catch (err) {
      if (err.response) {
        const errors = err.response.data.errors;
        if (errors) {
          errors.forEach((error) => message.error(error.msg));
        }
        dispatch(apiFail(err.response.data));
      } else {
        message.error(err.message);
        dispatch(apiFail(err.message));
      }
      return false;
    }
  };
};

export const reportsGet = (data) => {
  return async (dispatch) => {
    dispatch(apiStart());
    const headers = {
      "Content-Type": "application/json",
    };
    try {
      const response = await axiosBackEnd.get("/api/reports", {
        params: data,
        headers: headers,
      });
      dispatch(reportsGetSuccess(response.data));

      return true;
    } catch (err) {
      if (err.response) {
        const errors = err.response.data.errors;
        if (errors) {
          errors.forEach((error) => message.error(error.msg));
        }
        dispatch(apiFail(err.response.data));
      } else {
        message.error(err.message);
        dispatch(apiFail(err.message));
      }

      return false;
    }
  };
};

export const indexesGet = () => {
  return async (dispatch) => {
    dispatch(apiStart());
    const headers = {
      "Content-Type": "application/json",
    };
    try {
      const response = await axiosBackEnd.get("/api/indexes/legacy", null, {
        headers: headers,
      });
      dispatch(indexesGetSuccess(response.data));

      return true;
    } catch (err) {
      if (err.response) {
        const errors = err.response.data.errors;
        if (errors) {
          errors.forEach((error) => message.error(error.msg));
        }
        dispatch(apiFail(err.response.data));
      } else {
        message.error(err.message);
        dispatch(apiFail(err.message));
      }

      return false;
    }
  };
};

export const indexeCreate = (data) => {
  return async (dispatch) => {
    dispatch(apiStart());
    const headers = {
      "Content-Type": "application/json",
    };
    try {
      const response = await axiosBackEnd.post("/api/indexes", data, {
        headers: headers,
      });
      dispatch(indexeCreateSuccess(response.data));
      message.success(response.data.message);
      return true;
    } catch (err) {
      if (err.response) {
        const errors = err.response.data.errors;
        if (errors) {
          errors.forEach((error) => message.error(error.msg));
        }
        dispatch(apiFail(err.response.data));
      } else {
        message.error(err.message);
        dispatch(apiFail(err.message));
      }
      return false;
    }
  };
};

export const indexeUpdate = (data) => {
  return async (dispatch) => {
    dispatch(apiStart());
    const headers = {
      "Content-Type": "application/json",
    };
    try {
      const response = await axiosBackEnd.post("/api/indexes/update", data, {
        headers: headers,
      });
      dispatch(indexeUpdateSuccess(response.data));
      message.success(response.data.message);
      return true;
    } catch (err) {
      if (err.response) {
        const errors = err.response.data.errors;
        if (errors) {
          errors.forEach((error) => message.error(error.msg));
        }
        dispatch(apiFail(err.response.data));
      } else {
        message.error(err.message);
        dispatch(apiFail(err.message));
      }
      return false;
    }
  };
};

export const pmsGet = () => {
  return async (dispatch) => {
    dispatch(apiStart());
    const headers = {
      "Content-Type": "application/json",
    };
    try {
      const response = await axiosBackEnd.get("/api/pms", null, {
        headers: headers,
      });
      dispatch(pmsGetSuccess({error : false , message : "PMS Successfully get" , data : response.data }));

      return true;
    } catch (err) {
      message.error(err.response?.data?.message ?? "Error PMS");
      dispatch(apiFail(err.response.data.message ?? "Error PMS"));
      return false;
    }
  };
};

export const solutionsGet = () => {
  return async (dispatch) => {
    dispatch(apiStart());
    const headers = {
      "Content-Type": "application/json",
    };
    try {
      const response = await axiosBackEnd.get("/api/solutions/legacy", null, {
        headers: headers,
      });
      dispatch(solutionsGetSuccess(response.data));

      return true;
    } catch (err) {
      if (err.response) {
        const errors = err.response.data.errors;
        if (errors) {
          errors.forEach((error) => message.error(error.msg));
        }
        dispatch(apiFail(err.response.data));
      } else {
        message.error(err.message);
        dispatch(apiFail(err.message));
      }

      return false;
    }
  };
};

export const applicationsGet = () => {
  return async (dispatch) => {
    dispatch(apiStart());
    try {
      const response = await axiosBackEnd.get("/api/applications", null);
      dispatch(
        applicationsGetSuccess({
          error: false,
          message: "Successfully get",
          data: response.data,
        }),
      );

      return true;
    } catch (err) {
      dispatch(
        apiFail(err?.response?.data?.message ?? "Internal Server Error"),
      );
      // if (err.response) {
      //   const errors = err.response.data.errors;
      //   if (errors) {
      //     errors.forEach((error) => message.error(error.msg));
      //   }
      // } else {
      //   message.error(err.message);
      //   dispatch(apiFail(err.message));
      // }

      return false;
    }
  };
};

export const mainRolesGet = () => {
  return async (dispatch) => {
    dispatch(apiStart());
    const headers = {
      "Content-Type": "application/json",
    };
    try {
      const response = await axiosBackEnd.get("/api/main-roles", null, {
        headers: headers,
      });
      dispatch(mainRolesGetSuccess(response.data));

      return true;
    } catch (err) {
      if (err.response) {
        const errors = err.response.data.errors;
        if (errors) {
          errors.forEach((error) => message.error(error.msg));
        }
        dispatch(apiFail(err.response.data));
      } else {
        message.error(err.message);
        dispatch(apiFail(err.message));
      }

      return false;
    }
  };
};

export const mainRoleCreate = (data) => {
  return async (dispatch) => {
    dispatch(apiStart());
    const headers = {
      "Content-Type": "application/json",
    };
    try {
      const response = await axiosBackEnd.post("/api/main-roles", data, {
        headers: headers,
      });
      dispatch(mainRoleCreateSuccess(response.data));
      message.success(response.data.message);
      return true;
    } catch (err) {
      if (err.response) {
        const errors = err.response.data.errors;
        if (errors) {
          errors.forEach((error) => message.error(error.msg));
        }
        dispatch(apiFail(err.response.data));
      } else {
        message.error(err.message);
        dispatch(apiFail(err.message));
      }
      return false;
    }
  };
};

export const mainRoleUpdate = (data) => {
  return async (dispatch) => {
    dispatch(apiStart());
    const headers = {
      "Content-Type": "application/json",
    };
    try {
      const response = await axiosBackEnd.post("/api/main-roles/update", data, {
        headers: headers,
      });
      dispatch(mainRoleUpdateSuccess(response.data));
      message.success(response.data.message);
      return true;
    } catch (err) {
      if (err.response) {
        const errors = err.response.data.errors;
        if (errors) {
          errors.forEach((error) => message.error(error.msg));
        }
        dispatch(apiFail(err.response.data));
      } else {
        message.error(err.message);
        dispatch(apiFail(err.message));
      }
      return false;
    }
  };
};

export const hotelsGroupsGet = () => {
  return async (dispatch) => {
    dispatch(apiStart());
    const headers = {
      "Content-Type": "application/json",
    };
    try {
      const response = await axiosBackEnd.get("/api/hotels-groups", null, {
        headers: headers,
      });
      dispatch(hotelsGroupsGetSuccess(response.data));

      return true;
    } catch (err) {
      if (err.response) {
        const errors = err.response.data.errors;
        if (errors) {
          errors.forEach((error) => message.error(error.msg));
        }
        dispatch(apiFail(err.response.data));
      } else {
        message.error(err.message);
        dispatch(apiFail(err.message));
      }

      return false;
    }
  };
};

export const hotelsGroupCreate = (data) => {
  return async (dispatch) => {
    dispatch(apiStart());
    const headers = {
      "Content-Type": "application/json",
    };
    try {
      const response = await axiosBackEnd.post("/api/hotels-groups", data, {
        headers: headers,
      });
      dispatch(hotelsGroupCreateSuccess(response.data));
      message.success(response.data.message);
      return true;
    } catch (err) {
      if (err.response) {
        const errors = err.response.data.errors;
        if (errors) {
          errors.forEach((error) => message.error(error.msg));
        }
        dispatch(apiFail(err.response.data));
      } else {
        message.error(err.message);
        dispatch(apiFail(err.message));
      }
      return false;
    }
  };
};

export const hotelsGroupUpdate = (data) => {
  return async (dispatch) => {
    dispatch(apiStart());
    const headers = {
      "Content-Type": "application/json",
    };
    try {
      const response = await axiosBackEnd.post(
        "/api/hotels-groups/update",
        data,
        { headers: headers }
      );
      dispatch(hotelsGroupUpdateSuccess(response.data));
      message.success(response.data.message);
      return true;
    } catch (err) {
      if (err.response) {
        const errors = err.response.data.errors;
        if (errors) {
          errors.forEach((error) => message.error(error.msg));
        }
        dispatch(apiFail(err.response.data));
      } else {
        message.error(err.message);
        dispatch(apiFail(err.message));
      }
      return false;
    }
  };
};

export const signersGroupsGet = (data) => {
  return async (dispatch) => {
    dispatch(apiStart());
    const headers = {
      "Content-Type": "application/json",
    };
    try {
      const response = await axiosBackEnd.get("/api/signers-groups", {
        params: data,
        headers: headers,
      });
      dispatch(signersGroupsGetSuccess(response.data));

      return true;
    } catch (err) {
      if (err.response) {
        const errors = err.response.data.errors;
        if (errors) {
          errors.forEach((error) => message.error(error.msg));
        }
        dispatch(apiFail(err.response.data));
      } else {
        message.error(err.message);
        dispatch(apiFail(err.message));
      }

      return false;
    }
  };
};

export const signersGroupCreate = (data) => {
  return async (dispatch) => {
    dispatch(apiStart());
    const headers = {
      "Content-Type": "application/json",
    };
    try {
      const response = await axiosBackEnd.post("/api/signers-groups", data, {
        headers: headers,
      });
      dispatch(signersGroupCreateSuccess(response.data));
      message.success(response.data.message);
      return true;
    } catch (err) {
      if (err.response) {
        const errors = err.response.data.errors;
        if (errors) {
          errors.forEach((error) => message.error(error.msg));
        }
        dispatch(apiFail(err.response.data));
      } else {
        message.error(err.message);
        dispatch(apiFail(err.message));
      }
      return false;
    }
  };
};

export const signersGroupUpdate = (data) => {
  return async (dispatch) => {
    dispatch(apiStart());
    const headers = {
      "Content-Type": "application/json",
    };
    try {
      const response = await axiosBackEnd.post(
        "/api/signers-groups/update",
        data,
        { headers: headers }
      );
      dispatch(signersGroupUpdateSuccess(response.data));
      message.success(response.data.message);
      return true;
    } catch (err) {
      if (err.response) {
        const errors = err.response.data.errors;
        if (errors) {
          errors.forEach((error) => message.error(error.msg));
        }
        dispatch(apiFail(err.response.data));
      } else {
        message.error(err.message);
        dispatch(apiFail(err.message));
      }
      return false;
    }
  };
};

export const signersGroupsHotelUpdate = (data) => {
  return async (dispatch) => {
    dispatch(apiStart());
    const headers = {
      "Content-Type": "application/json",
    };
    try {
      const response = await axiosBackEnd.post(
        "/api/signers-groups/hotel-update",
        data,
        { headers: headers }
      );
      dispatch(signersGroupsHotelUpdateSuccess(response.data));
      message.success(response.data.message);
      return true;
    } catch (err) {
      if (err.response) {
        const errors = err.response.data.errors;
        if (errors) {
          errors.forEach((error) => message.error(error.msg));
        }
        dispatch(apiFail(err.response.data));
      } else {
        message.error(err.message);
        dispatch(apiFail(err.message));
      }
      return false;
    }
  };
};

export const bulkUserCreation = (data) => {
  return async (dispatch) => {
    const headers = {
      "Content-Type": "application/json",
    };
    try {
      const response = await axiosBackEnd.post(
        "/api/bulk-creation/user",
        data,
        { headers: headers }
      );
      dispatch(bulkUserCreationSuccess(response.data));
      // message.success(response.data.message);
      return response.data;
    } catch (err) {
      if (err.response) {
        const errors = err.response.data.errors;
        if (errors) {
          errors.forEach((error) => message.error(error.msg));
        }
        dispatch(apiFail(err.response.data));
      } else {
        message.error(err.message);
        dispatch(apiFail(err.message));
      }
      return false;
    }
  };
};

export const bulkReportCategoryCreation = (data) => {
  return async (dispatch) => {
    const headers = {
      "Content-Type": "application/json",
    };
    try {
      const response = await axiosBackEnd.post(
        "/api/bulk-creation/reportcategory",
        data,
        { headers: headers }
      );
      dispatch(bulkReportCategoryCreationSuccess(response.data));
      return response.data;
    } catch (err) {
      if (err.response) {
        const errors = err.response.data.errors;
        if (errors) {
          errors.forEach((error) => message.error(error.msg));
        }
        dispatch(apiFail(err.response.data));
      } else {
        message.error(err.message);
        dispatch(apiFail(err.message));
      }
      return false;
    }
  };
};

export const outOfOfficeCreate = (data) => {
  return async (dispatch) => {
    dispatch(apiStart());
    const headers = {
      "Content-Type": "application/json",
    };
    try {
      const response = await axiosBackEnd.post(
        "/api/signers-groups/out-of-office-create",
        data,
        { headers: headers }
      );
      dispatch(outOfOfficeCreateSuccess(response.data));
      message.success(response.data.message);
      return true;
    } catch (err) {
      if (err.response) {
        const errors = err.response.data.errors;
        if (errors) {
          errors.forEach((error) => message.error(error.msg));
        }
        dispatch(apiFail(err.response.data));
      } else {
        message.error(err.message);
        dispatch(apiFail(err.message));
      }
      return false;
    }
  };
};

export const outOfOfficeUpdate = (data) => {
  return async (dispatch) => {
    dispatch(apiStart());
    const headers = {
      "Content-Type": "application/json",
    };
    try {
      const response = await axiosBackEnd.post(
        "/api/signers-groups/out-of-office-update",
        data,
        { headers: headers }
      );
      dispatch(outOfOfficeUpdateSuccess(response.data));
      message.success(response.data.message);
      return true;
    } catch (err) {
      if (err.response) {
        const errors = err.response.data.errors;
        if (errors) {
          errors.forEach((error) => message.error(error.msg));
        }
        dispatch(apiFail(err.response.data));
      } else {
        message.error(err.message);
        dispatch(apiFail(err.message));
      }
      return false;
    }
  };
};

export const deleteItem = (data) => {
  return async (dispatch) => {
    dispatch(apiStart());
    const headers = {
      "Content-Type": "application/json",
    };
    try {
      const response = await axiosBackEnd.post("/api/delete", data, {
        headers: headers,
      });
      dispatch(deleteItemSuccess(response.data));
      message.success(response.data.message);
      return true;
    } catch (err) {
      if (err.response) {
        const errors = err.response.data.errors;
        if (errors) {
          errors.forEach((error) => message.error(error.msg));
        }
        dispatch(apiFail(err.response.data));
      } else {
        message.error(err.message);
        dispatch(apiFail(err.message));
      }
      return false;
    }
  };
};

export const checkItem = (data) => {
  return async (dispatch) => {
    dispatch(apiStart());
    const headers = {
      "Content-Type": "application/json",
    };
    try {
      await axiosBackEnd.post("/api/check-item", data, { headers: headers });
      dispatch(apiComplete());
      // message.success(response.data.message);
      return [];
    } catch (err) {
      if (err.response) {
        // const errors = err.response.data.errors;
        // if (errors) {

        //   // errors.forEach((error) => message.error(error.msg));
        // }
        dispatch(apiFail(err.response.data));
        return err.response.data.data;
      } else {
        message.error(err.message);
        dispatch(apiFail(err.message));
      }
      return [];
    }
  };
};

export const removeUserFromEnvelopeSigners = (data) => {
    return async (dispatch) => {
    dispatch(apiStart());
    const headers = {
      "Content-Type": "application/json",
    };
    try {
      await axiosBackEnd.delete(`/api/users/${data.user_id}/envelope-signers`, { data: data }, { headers: headers });
      dispatch(apiComplete());
      // message.success(response.data.message);
      return true;
    } catch (err) {
      if (err.response) {
        if (err.response.data && err.response.data.message) {
          message.error(err.response.data.message);
        } else {
          message.error("Error");
        }
        dispatch(apiFail(err.response.data));
      } else {
        message.error(err.message);
        dispatch(apiFail(err.message));
      }
      return false;
    }
  };
};



export const postEnvelope = (data) => {
  return async (dispatch) => {
    dispatch(apiStart());
    const headers = {
      "Content-Type": "application/json",
    };
    try {
      const response = await axiosBackEnd.post("/api/post-envelope", data, {
        headers: headers,
      });
      dispatch(apiComplete());
      // message.success(response.data.message);
      return response;
    } catch (err) {
      if (err.response) {
        const errors = err.response.data.errors;
        if (errors) {
          errors.forEach((error) => message.error(error.msg));
        }
        dispatch(apiFail(err.response.data));
      } else {
        message.error(err.message);
        dispatch(apiFail(err.message));
      }
      return false;
    }
  };
};

export const deleteSigners = (data) => {
  return async (dispatch) => {
    dispatch(apiStart());
    const headers = {
      "Content-Type": "application/json",
    };
    try {
      const response = await axiosBackEnd.post(
        "/api/post-envelope/delete-signers",
        data,
        { headers: headers }
      );
      // console.log(response, "response");
      dispatch(apiComplete());
      // message.success(response);
      return response.data;
    } catch (err) {
      if (err.response) {
        const errors = err.response.data.errors;
        if (errors) {
          errors.forEach((error) => message.error(error.msg));
        }
        dispatch(apiFail(err.response.data));
      } else {
        message.error(err.message);
        dispatch(apiFail(err.message));
      }
      return false;
    }
  };
};

export const filesGet = (data) => {
  console.log(data, "data.1");
  return async (dispatch) => {
    dispatch(apiStart());
    const headers = {
      "Content-Type": "application/json",
    };
    try {
      const response = await axiosBackEnd.get("/api/file-upload", {
        params: data,
        headers: headers,
      });
      dispatch(apiComplete());
      return response;
    } catch (err) {
      if (err.response) {
        const errors = err.response.data.errors;
        if (errors) {
          errors.forEach((error) => message.error(error.msg));
        }
        dispatch(apiFail(err.response.data));
      } else {
        message.error(err.message);
        dispatch(apiFail(err.message));
      }
      return false;
    }
  };
};

//Secondary envelope post data
export const updateSecondaryEnvelope = (data) => {
  return async (dispatch) => {
    dispatch(apiStart());
    const headers = {
      "Content-Type": "application/json",
    };
    try {
      const response = await axiosBackEnd.post(
        "/api/secondary-envelope/",
        data,
        { headers: headers }
      );
      dispatch(apiComplete());
      message.success(response.data.message);
      return response;
    } catch (err) {
      if (err.response) {
        const errors = err.response.data.errors;
        if (errors) {
          errors.forEach((error) => message.error(error.msg));
        }
        dispatch(apiFail(err.response.data));
      } else {
        message.error(err.message);
        dispatch(apiFail(err.message));
      }
      return false;
    }
  };
};

//Secondary envelope post manual trigger
export const setSecondaryEnvelopeManualTrigger = (data) => {
  return async (dispatch) => {
    dispatch(apiStart());
    const headers = {
      "Content-Type": "application/json",
    };
    try {
      const response = await axiosBackEnd.post(
        "/api/secondary-envelope/manual-trigger",
        data,
        { headers: headers }
      );
      dispatch(apiComplete());
      message.success(response.data.message);
      return response;
    } catch (err) {
      if (err.response) {
        const errors = err.response.data.errors;
        if (errors) {
          errors.forEach((error) => message.error(error.msg));
        }
        dispatch(apiFail(err.response.data));
      } else {
        message.error(err.message);
        dispatch(apiFail(err.message));
      }
      return false;
    }
  };
};
